<template>
    <div>
        <div v-if="res.price_fen == 0" class="course-price"><span class="price">免费</span></div>
        <div v-else class="course-price">
            <span class="price"><em>¥</em>{{fenToYuan(res.price_fen)}}</span>
            <template v-if="res.price_fen !== res.orig_price_fen && res.orig_price_fen !== 0">
                <span class="orig_price"><em>¥</em>{{fenToYuan(res.orig_price_fen)}}</span>
            </template>
        </div>
        <div v-if="isShowsSellTime" class="countdown_time">
            距停售还剩<span class="stop_sell_time">{{res.end_sell_countdown}}</span>天
        </div>
    </div>
</template>

<script>
export default {
    props: {
        res: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        // 是否展示停课倒计时
        isShowsSellTime() {
            if (!this.res.end_sell_countdown) {
                return false;
            }
            return Number(this.res.end_sell_countdown) !== -1;
        },
    }
};
</script>

<style lang="less" scoped>
@import "./price.less";
</style>
